<div class="mt-4">
  @for (v of thread; track $index) {
    <div class="mb-3">
      <div class="d-flex justify-content-between align-items-start border-bottom border-dark">
        <div class="font-size-base">{{ v.author }}</div>
        @if (v.entryType !== 'ticket') {
          <div class="font-size-smaller2 text-color-primary">
            {{ v.dateTime | date: 'dd.MM.yyyy HH:mm:ss' }}
          </div>
        }
        @if (v.entryType === 'ticket') {
          <div class="font-size-base">
            {{ v | entryType
            }}{{ v.entryType === 'ticket' ? ' #' + (ticket.deskTicket.ticketNumber ? ticket.deskTicket.ticketNumber : ' ---') + '' : '' }}
          </div>
        }
      </div>
      <div [innerHTML]="v.content" class="pt-2 pb-3"></div>
      @if (v?.attachments?.length) {
        <div class="pb-3">
          <h5 class="border-top pt-2">
            {{ 'tickets.threads.attachments' | transloco }}
          </h5>
          @for (attachment of v.attachments; track attachment.attachmentId) {
            <div>
              @if (attachment.isAgentAttachment) {
                <a [href]="attachment | attachmentLink: ticket" class="link link-underline" target="_blank" rel="noopener noreferrer">{{
                  attachment.name
                }}</a>
                <span class="font-size-smaller2 text-color-primary"> ({{ attachment | attachmentSize }})</span>
              } @else {
                <span class="font-size-smaller2 text-color-primary">{{ attachment.name }} ({{ attachment | attachmentSize }})</span>
              }
            </div>
          }
        </div>
      }
      @if (v.resolutionContent) {
        <div class="mt-3">
          <h5>
            {{ 'tickets.threads.solution' | transloco }}
          </h5>
          <p [innerHTML]="v.resolutionContent"></p>
        </div>
      }
    </div>
  }

  @if (!ticketCloseConfirm) {
    <div class="mt-4 d-flex" [zeroLoadingIndicator]="ongoingRequest">
      @if (ticket.deskTicket !== null && ticket.deskTicket.status !== 'Closed') {
        @if (dialogMode !== 'createComment') {
          <web-design-system-button data-zid="response-btn" type="primary" size="small" class="mr-4" (click)="createComment()">
            {{ 'tickets.threads.createComment' | transloco }}
          </web-design-system-button>
        }
        @if (ticket.type === 'OTHER' && dialogMode !== 'createComment') {
          <web-design-system-button type="secondary" size="small" (click)="ticketCloseConfirm = true">
            {{ 'tickets.threads.closeTicket' | transloco }}
          </web-design-system-button>
        }
      }
      @if (dialogMode === 'createComment') {
        <tickets-create-ticket
          class="flex-grow"
          [ticketRef]="ticket.deskTicket.id"
          (ticketCreationState)="commentCreationStateUpdate($event)"
        />
      }
    </div>
  }

  @if (ticketCloseConfirm) {
    <div class="mt-4 d-flex flex-column">
      <div class="font-size-base">
        {{ 'tickets.threads.closeConfirmMsg' | transloco }}
      </div>
      <div class="d-flex align-items-center mt-3">
        @if (ticket.type === 'OTHER' && dialogMode !== 'createComment') {
          <web-design-system-button type="primary" size="small" class="mr-4" (click)="updateTicketStatus('Closed')">
            {{ (ticket.deskTicket.status === 'Closed' ? 'tickets.threads.reopenTicket' : 'tickets.threads.closeTicket') | transloco }}
          </web-design-system-button>
        }
        <a class="link link-underline font-size-smaller1 cursor-pointer" (click)="ticketCloseConfirm = false">
          {{ 'tickets.threads.cancel' | transloco }}
        </a>
      </div>
    </div>
  }

  @if (showTicketClosedInfo) {
    <div class="mt-4">
      <div class="font-size-base">
        {{ 'tickets.threads.closedInfo' | transloco }}
      </div>
    </div>
  }

  @if (errors.length) {
    <div class="mt3">&nbsp;</div>
    <div class="mt3">
      @for (err of errors; track $index) {
        <p class="text-color-error">{{ err }}</p>
      }
    </div>
  }
</div>
